<template>
  <div v-show="visible" class="part mt-4">
    <div class="header_style justify-content-start">
      <h2 class="h2_style mb-0">Network</h2>
    </div>

    <div class="part__cnt">
      <div v-if="labelsHasData" class="label_style mt-3">
        <ul v-for="item in NetWorkValue" :key="item.label">
          <li>{{ item.label }}</li>
          <li>{{ item.value || '-' }}</li>
        </ul>
        
        <ul v-for="item in netNewFieldsData" :key="item.label">
          <li>{{ item.label }}</li>
          <li>{{ item.value }}</li>
        </ul>
      </div>

      <div v-show="hasData(flow_lineDataFields)" class="position-relative">
        <div id="flow_line" style="width: 100%; height: 400px"></div>
        <div id="flow_line_tip" class="position-absolute bg-white shadow rounded p-2" style="display: none"></div>
        <label-list ref="labelList1" :perf_second_data="perf_second_data" chartKey="flow_line_chart" />
        <chart-rect ref="chartRect1" chartKey="flow_line_chart" />
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import LabelList from '../label-list.vue'
import {allChart, arrNotEmpty} from '../common.js'
import ChartRect from '../rect.vue'

const useCharts = {
  props: {
    chartSettings: Object,
    perf_second_data: Object,
  },

  data() {
    return {
      flow_lineSeries: [
        {name: 'Send', dataKey: 'Send[KB/s]'},
        {name: 'Recv', dataKey: 'Recv[KB/s]'},
      ],
    }
  },

  computed: {
    secondData() {
      return this.perf_second_data?.['每秒数据']?.rows || {}
    },

    xData() {
      return this.secondData?.timeline || []
    },

    flow_lineDataFields() {
      return this.flow_lineSeries.map(item => item.dataKey)
    },

    
  },

  methods: {
    getOption() {
      return {
        title: {
          text: "Network",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: this.flow_lineSeries.map(item => {
          return {
            name: item.name,
            data: this.secondData?.[item.dataKey],
            type: "line",
            showSymbol: false,
            itemStyle: this.chartSettings.itemStyle2,
          }
        }),
      }
    },

    drawPieChartFlow() {
      let chartDom = document.getElementById("flow_line")
      if (!chartDom) return
      if (!allChart.flow_line_chart) {
        allChart.flow_line_chart = echarts.init(chartDom)
      }
      allChart.flow_line_chart.setOption(this.getOption(), {notMerge: true})
    },
  }
}

export default {
  mixins: [useCharts],
  
  inject: ['injectObj', 'hasData'],

  components: {LabelList, ChartRect},

  props: {
    testInfo3: Object,
    testInfo: Object,
    testInfo0: Object,
    netNewFieldsData: Array,
    testInfo2: Object,
  },

  data() {
    return {

    }
  },

  computed: {
    isAllChecked() {
      return this.injectObj.isAllChecked
    },

    NetWorkValue() {
      let data = this.testInfo3

      return [
        {
          label: "DPS[KB/s]",
          value: data?.dps,
        },
        {
          label: "Send[KB/s]",
          value: data?.send,
        },
        {
          label: "Recv[KB/s]",
          value: data?.recv,
        },
        // {
        //   label: "进程上行流量[KB/s]",
        //   value: this.testInfo?.process_up_flow,
        // },
        // {
        //   label: "进程下行流量[KB/s]",
        //   value: this.testInfo?.process_down_flow,
        // },
        // {
        //   label: "逻辑上行流量[KB/s]",
        //   value: this.testInfo?.logic_up_flow,
        // },
        // {
        //   label: "逻辑下行流量[KB/s]",
        //   value: this.testInfo?.logic_down_flow,
        // },
      ];
    },

    labelsHasData() {
      return arrNotEmpty(this.NetWorkValue) || arrNotEmpty(this.netNewFieldsData)
    },

    visible() {
      return this.labelsHasData || this.hasData(this.flow_lineDataFields)
    },
  },

  methods: {
    async init(isMounted) {
      this.drawPieChartFlow()
      await this.$nextTick()
      this.$refs.chartRect1?.init(isMounted)
    }
  }
}
</script>

<style scoped>
@import "../common.css"
</style>